import { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_KEY = "csa_destination_v1";

const SelectedCountryContext = createContext(null);

export function SelectedCountryProvider({ children }) {
  const [countries, setCountries] = useState([]);
  const [slug, setSlug] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || "";
    } catch {
      return "";
    }
  });

  // Load list of countries once — used by gate + header switcher
  useEffect(() => {
    axios.get(`${API}/countries`).then((r) => setCountries(r.data)).catch(() => {});
  }, []);

  // Persist whenever slug changes
  useEffect(() => {
    try {
      if (slug) localStorage.setItem(STORAGE_KEY, slug);
      else localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* quota */
    }
  }, [slug]);

  const country = useMemo(
    () => countries.find((c) => c.slug === slug) || null,
    [countries, slug]
  );

  const value = useMemo(
    () => ({
      slug,
      country,           // full {slug, name, flag, tagline, image} when loaded
      countries,         // full list (loaded async)
      setSlug,           // (newSlug: string)
      clear: () => setSlug(""),
      isLocked: Boolean(slug),
    }),
    [slug, country, countries]
  );

  return (
    <SelectedCountryContext.Provider value={value}>
      {children}
    </SelectedCountryContext.Provider>
  );
}

export function useSelectedCountry() {
  const ctx = useContext(SelectedCountryContext);
  if (!ctx) throw new Error("useSelectedCountry must be used inside SelectedCountryProvider");
  return ctx;
}
